import { ShopBackButtonService } from './services/shop-back-button.service';
import { AuthGuardService } from './services/auth-guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'bestellungen',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./historie/historie.module').then(m => m.HistoriePageModule)
  },
  {
    path: 'shop/:nr',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./shop/shop.module').then(m => m.ShopPageModule),
    canDeactivate: [ShopBackButtonService]
  },
  {
    path: 'shop/:nr/:kondition',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./shop/shop.module').then(m => m.ShopPageModule),
    canDeactivate: [ShopBackButtonService]
  },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule) },
  { path: 'info', loadChildren: () => import('./info/info.module').then(m => m.InfoPageModule) },
  { path: 'impressum', loadChildren: () => import('./impressum/impressum.module').then(m => m.ImpressumPageModule) },
  {
    path: 'ShopDetails',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./shop-details/shop-details.module').then(m => m.ShopDetailsPageModule)
  },
  {
    path: 'ShopSorten',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./shop-sorten/shop-sorten.module').then(m => m.ShopSortenPageModule)
  },
  {
    path: 'ShopConfirm',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./shop-confirm/shop-confirm.module').then(m => m.ShopConfirmPageModule)
  },
  {
    path: 'ChangePassword',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./change-password/change-password.module').then(m => m.ChangePasswordPageModule)
  },
  { path: '**', redirectTo: 'home', pathMatch: 'full' },
  { path: 'FilterPopover', loadChildren: () => import('./filter-popover/filter-popover.module').then(m => m.FilterPopoverPageModule) },
  { path: 'KonditionPopover', loadChildren: () => import('./kondition-popover/kondition-popover.module').then(m => m.KonditionPopoverPageModule) },
  { path: 'HistorieFilterPopover', loadChildren: () => import('./historie-filter-popover/historie-filter-popover.module').then(m => m.HistorieFilterPopoverPageModule) },
  { path: 'ShopOrder', loadChildren: () => import('./shop-order/shop-order.module').then(m => m.ShopOrderPageModule) },
  { path: 'info', loadChildren: () => import('./info/info.module').then(m => m.InfoPageModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
